"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _framerMotion = require("framer-motion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var swipeConfidenceThreshold = 1000;

var swipePower = function swipePower(offset, velocity) {
  return Math.abs(offset) * velocity;
};

var DefaultSlideWrapper = function DefaultSlideWrapper(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.div, _extends({
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, rest), children);
};

var Carousel = function Carousel(_ref2) {
  var activeIndex = _ref2.activeIndex,
      goPrev = _ref2.goPrev,
      goNext = _ref2.goNext,
      setLength = _ref2.setLength,
      resetDelay = _ref2.resetDelay,
      Wrapper = _ref2.Wrapper,
      SlideWrapper = _ref2.SlideWrapper,
      children = _ref2.children;

  var childrenArray = _react["default"].Children.toArray(children);

  (0, _react.useEffect)(function () {
    // Let useCarousel hook know how many pages there will be.
    setLength(childrenArray.length);
  }, [childrenArray]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    style: {
      // We define these as inline styles so passed in Wrappers won't override them.
      display: 'grid',
      touchAction: 'pan-y' // needed to pick up onPanEnd

    },
    as: _framerMotion.motion.div,
    transition: {
      duration: 3
    },
    onPanEnd: function onPanEnd(_, _ref3) {
      var offset = _ref3.offset,
          velocity = _ref3.velocity,
          rest = _objectWithoutProperties(_ref3, ["offset", "velocity"]);

      // User is probably attempting to scroll the window. Don't do anything.
      if (Math.abs(velocity.y) > Math.abs(velocity.x)) return;
      var swipe = swipePower(offset.x, velocity.x);

      if (swipe > swipeConfidenceThreshold) {
        goPrev();
      } else if (swipe < -swipeConfidenceThreshold) {
        goNext();
      }

      resetDelay();
    }
  }, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    initial: false
  }, /*#__PURE__*/_react["default"].createElement(SlideWrapper, {
    key: activeIndex,
    style: {
      // We define these as inline styles so passed in Wrappers won't override them.
      gridColumn: '1',
      gridRow: '1'
    }
  }, childrenArray[activeIndex])));
};

Carousel.propTypes = {
  activeIndex: _propTypes["default"].number.isRequired,
  goPrev: _propTypes["default"].func.isRequired,
  goNext: _propTypes["default"].func.isRequired,
  setLength: _propTypes["default"].func.isRequired,
  Wrapper: _propTypes["default"].any,
  // Neither element nor node are working here for some reason.
  SlideWrapper: _propTypes["default"].any,
  // Neither element nor node are working here for some reason.
  children: _propTypes["default"].node
};
Carousel.defaultProps = {
  Wrapper: _framerMotion.motion.div,
  SlideWrapper: DefaultSlideWrapper
};
var _default = Carousel;
exports["default"] = _default;